import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import get from "@insite/mobius/utilities/get";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css, ThemeProps, withTheme } from "styled-components";

const enum fields {
    content = "content",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.content]: string;
    };
}

export interface CategoryContentStyles {
    cardWrapper?: TypographyProps;
    pageTitleStyles?: InjectableCss;
}

export const CategoryStyles: CategoryContentStyles = {
    pageTitleStyles: {
        css: css`
            text-align: center;
            margin-bottom: 32px;
        `,
    },
};

const styles = CategoryStyles;

export const CENCategoryContent: FC<OwnProps & ThemeProps<BaseTheme>> = ({ id, fields, theme }) => {
    const cardWrapper = {
        css: css`
            color: ${getProp("theme.typography.p.color")};
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.large};
            line-height: ${TYPOGRAPHY.lineHeight.base};
            margin-bottom: 44px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: ${TYPOGRAPHY.size.base} !important;
                        line-height: 20px !important;
                        margin-bottom: 28px;
                    `,
                    css`
                        font-size: ${TYPOGRAPHY.size.base} !important;
                        line-height: 20px !important;
                        margin-bottom: 28px;
                    `,
                    css`
                        font-size: ${TYPOGRAPHY.size.base} !important;
                        line-height: 20px !important;
                        margin-bottom: 28px;
                    `,
                    null,
                    null,
                ])}
        `,
    };

    return (
        <>
            <StyledWrapper {...styles.pageTitleStyles}>
                <Zone contentId={id} zoneName="PageTitleZone"></Zone>
            </StyledWrapper>
            <StyledWrapper {...cardWrapper}>{fields.content}</StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withTheme(CENCategoryContent),
    definition: {
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.content,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
